import axios from "axios";
import { config } from "config/env";
import { createTokenRefreshInterceptor } from "./tokenRefresh";

const API_URL = config.api.baseUrl;
export const WarehouseAxios = axios.create({
  baseURL: API_URL,
  withCredentials: true, // Uncomment if using cookies/sessions
  headers: {
    "Content-Type": "application/json",
  },
});

WarehouseAxios.interceptors.request.use(
  (request) => {
    try {
      const user_data = localStorage.getItem("authUser");

      if (user_data) {
        const parsed = JSON.parse(user_data);
        const TOKEN = parsed?.access;

        if (TOKEN) {
          request.headers.Authorization = `Bearer ${TOKEN}`;
        } else {
          console.warn("No access token found in authUser.");
        }
      } else {
        console.warn(" No authUser found in localStorage.");
      }

      return request;
    } catch (err) {
      console.error("Failed to parse token from localStorage:", err);
      return request;
    }
  },
  (error) => {
    return Promise.reject(error);
  }
);

WarehouseAxios.interceptors.response.use(
  (response) => response,
  createTokenRefreshInterceptor(WarehouseAxios)
);
